import { useState } from "react";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Audiences } from "@/components/Audiences";
import { Portfolio } from "@/components/Portfolio";
import { Testimonials } from "@/components/Testimonials";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import { Pricing } from "@/components/Pricing";
import { Process } from "@/components/Process";
import { Faq } from "@/components/Faq";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { scrollToSection } from "@/lib/scroll";

export default function Home() {
  const [selectedOffer, setSelectedOffer] = useState("");

  const chooseOffer = (offer) => {
    setSelectedOffer(offer);
    scrollToSection("contact");
  };

  return (
    <div className="min-h-screen bg-cream text-slate-900">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Audiences />
        <Portfolio />
        <Testimonials />
        <Pricing onSelect={chooseOffer} />
        <Process />
        <Faq />
        <Contact selectedOffer={selectedOffer} />
      </main>
      <Footer />
      <WhatsAppButton />
      <Toaster position="top-center" richColors />
    </div>
  );
}
